import React from "react";
import "./legal.css";

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <div className="legal-content">
          <p><strong>Last Updated: August 19, 2026</strong></p>
          <p>
            Customs Pro AI ("we," "us," or "our") provides HS code classification tools, AI-powered product analysis, and subscription-based services. This Privacy Policy explains how we collect, use, store, and protect your personal information when you use our website, mobile app, and related services (the "Service"). By using Customs Pro AI, you agree to the practices described in this Privacy Policy.
          </p>

          <h2>1. Information We Collect</h2>
          
          <h3>1.1 Information You Provide</h3>
          <ul>
            <li><strong>Account details:</strong> name, email address, password</li>
            <li><strong>Subscription details:</strong> plan selection, billing history</li>
            <li><strong>Product information:</strong> descriptions, text inputs, or other data you submit for HS code classification. This data is processed only to fulfil your request and is <strong>not saved</strong> after the classification is returned. It is <strong>not used to train</strong> any AI models.</li>
            <li><strong>Support requests:</strong> messages sent to support@customspro.ai</li>
          </ul>

          <h3>1.2 Payment Information</h3>
          <p>
            We do not store credit card details. All payments are securely processed by Stripe, which may collect:
          </p>
          <ul>
            <li>Cardholder name</li>
            <li>Card number</li>
            <li>Billing address</li>
            <li>Transaction metadata</li>
          </ul>
          <p>Stripe handles this information according to its own Privacy Policy.</p>

          <h3>1.3 Automatically Collected Information</h3>
          <ul>
            <li>Device type and operating system</li>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Usage logs</li>
            <li>Crash reports</li>
            <li>Analytics data (e.g., page views, feature usage)</li>
          </ul>

          <h3>1.4 Cookies and Tracking</h3>
          <p>We may use cookies or similar technologies to:</p>
          <ul>
            <li>Maintain login sessions</li>
            <li>Improve performance</li>
            <li>Analyse usage patterns</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain the Customs Pro AI service</li>
            <li>Process subscription payments</li>
            <li>Process product inputs solely to return HS code classifications (these inputs are not retained and are not used to train AI models)</li>
            <li>Communicate with you about updates, billing, or support</li>
            <li>Prevent fraud and ensure platform security</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>3. How We Share Your Information</h2>
          <p>We do not sell your personal information.</p>
          <p>We may share information with:</p>

          <h3>3.1 Service Providers</h3>
          <ul>
            <li>Stripe (payment processing)</li>
            <li>Hosting providers (Netlify, AWS, Google Firebase)</li>
            <li>Analytics providers</li>
          </ul>
          <p>These partners only receive the minimum data required to perform their services.</p>

          <h3>3.2 Legal Requirements</h3>
          <p>We may disclose information if required to comply with:</p>
          <ul>
            <li>Australian law</li>
            <li>Court orders</li>
            <li>Regulatory authorities</li>
          </ul>

          <h2>4. Data Storage and Security</h2>
          <p>We use industry-standard security measures including:</p>
          <ul>
            <li>Encryption in transit (HTTPS)</li>
            <li>Secure authentication</li>
            <li>Access controls</li>
            <li>Regular security reviews</li>
          </ul>
          <p>
            Despite these measures, no system is completely secure. We encourage strong passwords and responsible account management.
          </p>

          <h2>5. International Data Transfers</h2>
          <p>
            Your information may be stored or processed outside Australia. Where this occurs, we ensure appropriate safeguards are in place consistent with the Australian Privacy Act and GDPR.
          </p>

          <h2>6. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your data</li>
            <li>Request a copy of your data</li>
            <li>Withdraw consent</li>
            <li>Object to certain processing activities</li>
          </ul>
          <p>
            To exercise these rights, contact us at{" "}
            <a href="mailto:support@customspro.ai">support@customspro.ai</a>.
          </p>

          <h2>7. Data Retention</h2>
          <p>We retain personal information only as long as necessary for:</p>
          <ul>
            <li>Providing the service</li>
            <li>Legal compliance</li>
            <li>Resolving disputes</li>
            <li>Enforcing agreements</li>
          </ul>
          <p>You may request deletion of your account and associated data at any time.</p>

          <h2>8. Children’s Privacy</h2>
          <p>
            Customs Pro AI is not intended for individuals under 18. We do not knowingly collect information from children.
          </p>

          <h2>9. Third-Party Links</h2>
          <p>
            Our service may contain links to external websites. We are not responsible for the privacy practices of third-party sites.
          </p>

          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. The “Last Updated” date reflects the most recent revision. Continued use of the Service after changes constitutes acceptance of the updated Policy.
          </p>

          <h2>11. Contact Us</h2>
          <p>
            For questions or privacy requests, contact us at{" "}
            <a href="mailto:support@customspro.ai">support@customspro.ai</a>.
            <br />
            Customs Pro AI — Victoria, Australia
          </p>
        </div>

        <button className="close-btn" onClick={() => window.close()}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Privacy;